let SplideOptions = {
  type: 'loop',
  perPage: 1,
  arrows: true,
  pagination: true,
  easing: 'cubic-bezier(0.25, 1, 0.5, 1)', // mobile : effet plus “glissant”
};

// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.splide').forEach(function (el) {
//     new Splide(el, SplideOptions).mount();
//     console.log('Splide mounted on', el);
//   });

//   document.querySelectorAll('.splide__arrow').forEach(function (arrow) {
//     arrow.addEventListener('click', function (e) {
//       e.stopPropagation();
//     });
//   });
// });

// Observer pour les carrousels Splide et réinitialisation

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      // Réinitialise les Splide carrousels fraîchement injectés
      document.querySelectorAll('.splide').forEach((el) => {
        if (!el.classList.contains('is-initialized')) {
          // console.log('Initializing Splide on', el);
          new Splide(el, SplideOptions).mount();
          el.classList.add('is-initialized');
        }
      });
    }
  });
});

const grid = document.querySelector('.product-grid-container');

if (grid) {
  observer.observe(grid, { childList: true, subtree: true });
}

// curseur d'indication a scroller sur la homepage

if (document.getElementById('scrollCurseur')) {
  let lastScrollTop = window.scrollY;
  window.addEventListener('scroll', () => {
    const curseur = document.getElementById('scrollCurseur');
    const currentScroll = window.scrollY;

    const isScrollingDown = currentScroll > lastScrollTop;
    const isAtTop = currentScroll <= 10;

    if (isAtTop) {
      curseur.classList.remove('is-hide');
    } else if (isScrollingDown) {
      curseur.classList.add('is-hide');
    }

    lastScrollTop = currentScroll;
  });
}

// accordion fiche produit
const accordionHeaders = document.querySelectorAll('.accordion__header');
accordionHeaders.forEach((header) => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling;
    const isOpen = content.style.maxHeight;

    // Close all other accordions
    document.querySelectorAll('.accordion__content').forEach((item) => {
      item.style.maxHeight = null;
    });

    // Toggle the clicked accordion
    if (isOpen) {
      content.style.maxHeight = null;
      content.classList.remove('open');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.classList.add('open');

      // GTA event
      const titleElement = header.querySelector('.summary__title h2');
      const title = titleElement ? titleElement.textContent.trim() : '';
      console.log('Accordéon ouvert:', title);
      if (typeof gtag === 'function') {
        gtag('event', 'accordeon', {
          tab_ouvert: title,
        });
      }
    }
  });
});

let ratioX;
let ratioY;

document.querySelectorAll('.product__media-list .scp-gallery-scroll').forEach((gallery, index) => {
  const media = gallery.querySelector('.product__media');
  if (!media) return;

  const image = media.querySelector('img');
  if (!image) return;

  gallery.addEventListener('click', (event) => {
    // Position du clic relatif au container
    const rect = gallery.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const clickY = event.clientY - rect.top;

    ratioX = clickX / rect.width;
    ratioY = clickY / rect.height / 0.7;

    // Attributs HTML width/height
    const attrWidth = Number(image.getAttribute('width'));
    const attrHeight = Number(image.getAttribute('height'));
  });
});

function centerProductModalImage() {
  const container = document.querySelector('.product-media-modal__content');
  if (!container) return;

  const image = container.querySelector('img.active');
  if (!image) return;

  const scrollImageToCenter = () => {
    const scrollAmountX = image.scrollHeight * ratioX;
    const scrollAmountY = image.scrollWidth * ratioY;

    container.scrollTo({ left: scrollAmountX / 2, top: scrollAmountY / 2 });
  };

  if (image.complete) {
    scrollImageToCenter();
  } else {
    image.addEventListener('load', scrollImageToCenter, { once: true });
  }
}
// Observer l'ajout de l'attribut `open` sur <product-modal>
const productModal = document.querySelector('product-modal');

if (productModal) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open' && productModal.hasAttribute('open')) {
        // Attendre le prochain rendu pour être sûr que l'image est dans le DOM
        requestAnimationFrame(() => {
          centerProductModalImage();
        });
      }
    }
  });

  observer.observe(productModal, {
    attributes: true,
  });
}

// Carousel de produits Fiche produit

const track = document.querySelector('.carousel-track');
if (track) {
  const slides = track.querySelectorAll('img');
  const prevBtn = document.querySelector('.arrow.prev');
  const nextBtn = document.querySelector('.arrow.next');
  const viewport = document.querySelector('.carousel-viewport');
  const nbImagesMobile = 1;
  const nbImagesDesktop = 5;
  const nbImageDecalage = nbImagesDesktop - 1;

  let index = 0;

  function updateSlide() {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      track.style.transform = `translateX(-${index * 100}%)`;
    } else {
      track.style.transform = `translateY(-${index * (100 / nbImagesDesktop) * nbImageDecalage}%)`;
    }
  }

  function getMaxIndex() {
    return window.innerWidth < 768 ? slides.length - 1 : slides.length / nbImageDecalage - 1;
  }

  nextBtn.addEventListener('click', () => {
    if (index < getMaxIndex()) {
      index++;
      updateSlide();
    }
  });

  prevBtn.addEventListener('click', () => {
    if (index > 0) {
      index--;
      updateSlide();
    }
  });

  // Autorise scroll manuel sur mobile sans bloquer
  viewport.addEventListener('scroll', () => {
    if (window.innerWidth < 768) {
      const scrollLeft = viewport.scrollLeft;
      const viewportWidth = viewport.offsetWidth;
      index = Math.round(scrollLeft / viewportWidth);
    }
  });

  window.addEventListener('resize', () => {
    updateSlide();
  });

  updateSlide();
}

//Accordeon texte image section

// Initialisation de l'accordéon mobile
document.addEventListener('DOMContentLoaded', function () {
  const accordionBlocs = document.querySelectorAll('.accordion-bloc');

  accordionBlocs.forEach(function (bloc) {
    const toggleBtn = bloc.querySelector('.accordion-toggle');
    const collapsible = bloc.querySelector('.accordion-content');

    // Hide toggle if no accordion-content inside accordion-bloc
    if (toggleBtn && !collapsible) {
      toggleBtn.style.display = 'none';
      return;
    }

    if (!toggleBtn || !collapsible) return;

    toggleBtn.addEventListener('click', function () {
      const isExpanded = bloc.classList.contains('is-expanded');

      bloc.classList.toggle('is-expanded');
      toggleBtn.setAttribute('aria-expanded', !isExpanded);
      toggleBtn.querySelector('.accordion__toggle-text').textContent = isExpanded ? 'Lire plus' : 'Lire moins';

      // Optionnel : scroll vers le bouton si on ferme
      if (isExpanded) {
        setTimeout(() => {
          toggleBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 300);
      }
    });
  });
});
